<script type="text/babel">
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'

export default {
    mixins: [RestoreOnPageBack],
    props: ['user'],

    data() {
        return {
            form: new SparkForm(this.user),
        }
    },

    computed: {
        busy() {
            return this.form.busy
        },
    },

    methods: {
        update() {
            Spark.sendForm('put', route('api.profile.update'), this.form).then(response => {
                Bus.$emit('userUpdated', response.data)
                Object.assign(this.form, response.data)
            })
        },
    },
}
</script>
